import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { colorsTheme } from 'resources/theme/styled/colors';
import { useEntityIntakeFormContext } from '../../EntityIntakeFormContext';

// components
import { AsyncButton, SectionIntro, Text } from '@ui';

const Accepted = () => {
  const { t } = useTranslation(['onboarding', 'common']);
  const { startOnboarding } = useEntityIntakeFormContext();

  return (
    <>
      <SectionIntro
        hideDivider
        titleColor={colorsTheme.colorWhite}
        title={t('intake_form.accepted.title')}
      />
      <TextWithTopMargin>
        {t('intake_form.accepted.description_line_1')}
      </TextWithTopMargin>
      <TextWithTopMargin>
        {t('intake_form.accepted.description_line_2')}
      </TextWithTopMargin>
      <StyledButton size="large" onClick={startOnboarding}>
        {t('intake_form.accepted.button')}
      </StyledButton>
    </>
  );
};

const TextWithTopMargin = styled(Text)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

const StyledButton = styled(AsyncButton)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

export default Accepted;
